import { LocalDate } from "@js-joda/core";

/**
 * Shared rule for applying salary/tax changes:
 * - date must be set
 * - date must be the 1st day of month
 * - date must be on/after earliest selectable date when provided
 */
export const canApplyMonthlyEffectiveDate = (
  effectiveDate: LocalDate | null,
  earliestSelectableDate: LocalDate | null,
): boolean => {
  if (effectiveDate == null) return false;
  if (effectiveDate.dayOfMonth() !== 1) return false;
  if (earliestSelectableDate == null) return true;
  return !effectiveDate.isBefore(earliestSelectableDate);
};
